export const BASIC_CARD_NAME = 'Basic';
export const PREMIUM_CARD_NAME = 'Business World Debit';
